import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle
} from '@/components/ui/sheet';
import { Search } from 'lucide-react';

import { useCartCookie } from '@/helpers/useCartCookie';
import { useCartIsOpen } from '@/app/cart/useCartIsOpen';
import Cart from './cartSheet/Cart';

import {
  Empty,
  EmptyIcon,
  EmptyTitle,
  EmptyDescription
} from '@/components/ui/empty';

const CartSheet = () => {
  const { toggleCart, isCartOpen } = useCartIsOpen();
  const { getCartId } = useCartCookie();
  const cartId = getCartId();

  return (
    <Sheet open={isCartOpen} onOpenChange={toggleCart}>
      <SheetContent>
        <SheetHeader>
          <SheetTitle className="text-xl font-bold mb-4">
            Cart Summary
          </SheetTitle>
        </SheetHeader>
        {!cartId && (
          <Empty>
            <EmptyIcon>
              <Search />
            </EmptyIcon>
            <EmptyTitle>No Items in cart</EmptyTitle>
            <EmptyDescription>Go find your Pro!</EmptyDescription>
          </Empty>
        )}
        {cartId && <Cart cartId={cartId} />}
      </SheetContent>
    </Sheet>
  );
};

export default CartSheet;
